import { motion } from "motion/react";

export function AboutPage() {
  return (
    <main className="min-h-screen bg-gradient-to-br from-[#051F20] via-[#0B2B26] to-[#163832] py-12 md:py-20 px-4 sm:px-6 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(circle at 40px 40px, #8EB69B 1%, transparent 1%)",
            backgroundSize: "80px 80px",
          }}
        />
      </div>

      <motion.div
        className="relative mx-auto w-full max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {/* Header Section */}
        <div className="mb-12">
          <div className="flex items-center gap-2 rounded-full border border-[#8EB69B]/30 bg-[#051F20]/60 px-4 py-2 text-xs font-medium text-[#C9A961] uppercase tracking-wider mb-6 w-fit">
            <span className="h-1.5 w-1.5 rounded-full bg-[#C9A961]" />
            About Kalpakrushi
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 tracking-tight leading-tight block">
            About Kalpakrushi
          </h1>
          <p className="text-sm text-[#8EB69B] mb-6 font-medium block">
            Kalpakrushi AgriTech • Company Overview
          </p>
          <p className="text-lg md:text-xl text-white/90 leading-relaxed block">
            Kalpakrushi AgriTech is a future-focused agricultural technology company committed to transforming traditional farming into a smart, sustainable, and profitable ecosystem.
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          {[
            "Rooted in India’s rich agricultural heritage and driven by innovation, Kalpakrushi empowers farmers with smart devices, digital platforms, and data-driven insights that improve productivity, reduce risk, and enhance income. We bridge the gap between age-old farming wisdom and modern technology.",
            "Our solutions combine IoT-enabled smart agriculture devices, a farmer-friendly mobile application, and expert advisory services to support farmers across the entire crop lifecycle — from soil preparation to harvest and beyond.",
          ].map((text, i) => (
            <div
              key={i}
              className="group bg-white/5 border border-[#8EB69B]/15 rounded-xl p-6 md:p-7 backdrop-blur-sm transition-all duration-300 hover:border-[#8EB69B]/30 hover:bg-white/8"
            >
              <div className="flex items-start gap-3">
                <span className="h-2.5 w-2.5 rounded-full bg-[#8EB69B] flex-shrink-0 mt-1" />
                <div className="flex-1">
                  <div className="text-white/90 text-base md:text-lg leading-relaxed block">
                    {text}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-[#8EB69B]/15 text-sm text-white text-center">
          © 2026 Kalpakrushi AgriTech. All rights reserved.
        </div>
      </motion.div>
    </main>
  );
}
